import { useObservability } from '@opendoor/observability';
import {
  SellerFlowAddressInput,
  IProps as SellerFlowAddressInputProps,
} from './SellerFlowAddressInput';
import { TrackingTaxonomy, AddressSearchLocation } from '../globals';
import { CTAProps } from '@opendoor/bricks/complex/CtaInput';

export type AddressSearchProp = Pick<CTAProps, 'actionText' | 'actionTextSmall' | 'size'> &
  Pick<
    SellerFlowAddressInputProps,
    'channel' | 'autoFocus' | 'onFocus' | 'paddingLevel' | 'hideLabel' | 'placeholderText'
  > & {
    trackingTaxonomy: TrackingTaxonomy;
    inputLocation: AddressSearchLocation;
    displayResultsAbove?: boolean;
    analyticsPrefix?: string;
  };

const AddressSearch = ({
  trackingTaxonomy,
  inputLocation,
  autoFocus,
  onFocus,
  paddingLevel,
  actionText,
  actionTextSmall,
  placeholderText,
  size,
  hideLabel,
  displayResultsAbove = false,
  analyticsPrefix = 'cosmos',
  channel,
}: AddressSearchProp) => {
  const { trackEvent } = useObservability();

  let addressAttemptCount = 0;
  const onChooseInvalidEntry = () => {
    // TODO: remove categoryOverride
    // observability is initialized with 'cosmos' as the category for all events
    trackEvent(
      'submit',
      'failed-address-attempt',
      {
        eventValue: ++addressAttemptCount,
      },
      { categoryOverride: 'address-search' },
    );
  };

  const onQueryChange = (newQuery?: string, oldQuery?: string) => {
    if (oldQuery === '' && newQuery && newQuery.length > 0) {
      // TODO: remove categoryOverride
      // observability is initialized with 'cosmos' as the category for all events
      trackEvent('typing', trackingTaxonomy, {}, { categoryOverride: 'address-input' });
    }
  };

  return (
    <SellerFlowAddressInput
      analyticsName={`${analyticsPrefix}-address-input`}
      autoFocus={autoFocus || false}
      inputLocation={inputLocation}
      onChooseInvalidEntry={onChooseInvalidEntry}
      trackingTaxonomy={trackingTaxonomy}
      onQueryChange={onQueryChange}
      hideLabel={hideLabel}
      designStyle="rounded"
      showShadow
      size={size}
      onFocus={onFocus}
      paddingLevel={paddingLevel}
      displayAbove={displayResultsAbove}
      placeholderText={placeholderText}
      showCta
      channel={channel}
      ctaProps={{
        actionText,
        actionTextSmall,
        'aria-label': 'Submit address',
      }}
    />
  );
};

export default AddressSearch;
